<p-dialog
  [(visible)]="visible"
  [style]="{ width: '40vw' }"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeModal()"
>
  <ng-template pTemplate="closeicon">
    <span class="closeicon pi pi-times"></span>
  </ng-template>
  <ng-template pTemplate="header">
    Verschiebungs-Historie
  </ng-template>
  <ng-template pTemplate="content">
    @if (histories.length > 0) {
      <ul>
        @for (history of sortedHistories; track history) {
          <li>
            <div class="move-history-entry">
              <span class="date">{{ history.createdAt | date:'dd.MM.yyyy, HH:mm' }}</span>
              <span class="from-to">
                <span class="from">{{ getShelterNameById(history.oldShelterId) }}</span>
                <span class="arrow">→</span>
                <span class="to">{{ getShelterNameById(history.newShelterId) }}</span>
              </span>
              <span class="book-number">(Buchnummer: {{ history.oldBookNumber }})</span>
            </div>
          </li>
        }
      </ul>
    }
    @if (histories.length === 0) {
      <p>Keine Verschiebungen vorhanden.</p>
    }
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        (click)="closeModal()"
        label="{{'modal.cancel' | transloco}}"
        icon="pi pi-times"
        [text]="true"
      />
      <p-button
        styleClass="p-button-warning"
        (click)="saveChanges()"
        [disabled]="histories.length === 0"
        icon="pi pi-undo"
        label="{{'moveAnimal.undo' | transloco}}"
      />

    </div>
  </ng-template>
</p-dialog>
